import { formatScheduleLocalSlot, scheduleRelative } from "../../lib/scheduled-job-display"
import type { ScheduleSlot } from "../../services/use-scheduled-jobs"

export function ScheduleSlots({
  slots,
  timeZone,
  isEnabled = true,
}: {
  slots: readonly ScheduleSlot[]
  timeZone: string
  isEnabled?: boolean
}) {
  return (
    <>
      {!isEnabled ? (
        <p className="preview-note">
          <strong>Paused.</strong> Nothing runs until you resume. These are the slots it would use.
        </p>
      ) : null}

      <ul className="slot-list">
        {slots.map((slot) => (
          <li key={slot.instant}>
            <span>{formatScheduleLocalSlot(slot.localSlot)}</span>

            <span className="rel">{scheduleRelative(slot.instant, timeZone)}</span>
          </li>
        ))}
      </ul>

      {!slots.length ? <p className="preview-note">No upcoming slots are available.</p> : null}
    </>
  )
}
